<template>
    <div class="subscribe-page ac">
      <div class="logo mt20" style="margin-top: 50px;">
        <img src="../../static/images/logo-new.png">
      </div>
		<div class="unsub-btn por">
			<div class="button active" @click="getShowLogin">{{$t('playNow')}}</div>
		</div>

	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

        return {
			notFound:false,

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){

	},
    methods: {
      getShowLogin(){
        this.$router.push({path:'/register'})
      },
		getHome(){
			let that =this;
			that.$api.post('/Home/homeData',null,r =>{
				that.$parent.returnCode(r,function(){
					that.$parent.loadModal(false);
          });

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/subscribe.vue